'use strict';

exports.__esModule = true;
exports.ObjectContext = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ViewModule = require('material-ui-icons/ViewModule');

var _ViewModule2 = _interopRequireDefault(_ViewModule);

var _ = require('..');

var _2 = _interopRequireDefault(_);

var _3 = require('../../../..');

var _4 = _interopRequireDefault(_3);

var _Iterable = require('./Iterable');

var _Iterable2 = _interopRequireDefault(_Iterable);

var _NamedField = require('../Fields/NamedField');

var _NamedField2 = _interopRequireDefault(_NamedField);

var _DefaultValue = require('../Fields/NamedField/DefaultValue');

var _DefaultValue2 = _interopRequireDefault(_DefaultValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ObjectContext = exports.ObjectContext = (0, _react.createContext)({});
var ListView = (_temp = _class = function (_EditorComponent) {
  _inherits(ListView, _EditorComponent);

  function ListView() {
    _classCallCheck(this, ListView);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  ListView.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_ViewModule2.default, null), ' List View'));
  };

  ListView.prototype.getRenderProps = function getRenderProps() {
    var _EditorComponent$prot = _EditorComponent.prototype.getRenderProps.call(this),
        style = _EditorComponent$prot.style,
        props = _objectWithoutProperties(_EditorComponent$prot, ['style']);

    return _extends({
      style: _extends({}, style, {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap"
      })
    }, props);
  };

  ListView.prototype.canBeParent = function canBeParent(parent) {
    var can = false; // return false;

    if (_EditorComponent.prototype.canBeParent.call(this, parent)) {
      while (parent) {
        if (parent instanceof _2.default || parent instanceof _NamedField2.default) {
          can = true;
          break;
        }

        parent = parent.props.parent;
      }
    }

    return can;
  };

  ListView.prototype.renderMainView = function renderMainView() {
    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    return inEditMode ? _EditorComponent.prototype.renderMainView.call(this) : this.renderChildren();
  };

  ListView.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var _getComponentProps = this.getComponentProps(this),
        style = _getComponentProps.style,
        other = _objectWithoutProperties(_getComponentProps, ['style']);

    var Grid = this.context.Grid;
    return _react2.default.createElement(_.ConnectorContext.Consumer, null, function (context) {
      var data = context.data;

      if (!data) {
        return null;
      }

      var objects = data.objects,
          objectsConnection = data.objectsConnection,
          otherData = _objectWithoutProperties(data, ['objects', 'objectsConnection']);

      var items = objects ? objects : objectsConnection ? objectsConnection.edges.map(function (n) {
        return n.node;
      }) : null;

      if (!items) {
        return null;
      }

      var children = _EditorComponent.prototype.renderChildren.call(_this2) || [];
      var output = null;
      /**
      Так как в некоторых случаях нам надо вывести полученные данные без лишних оберток,
      проверяем является ли дочерний элемент производным от Iterable.
      Если является таковым, то рендерим в него все полученные объекты
       */

      {
        /* if (children.length === 1 && children[0].__proto__.isPrototypeOf(Iterable)) { */
      }

      if (children.length === 1 && children[0] && (_Iterable2.default.isPrototypeOf(children[0].type) || children[0].type === _Iterable2.default)) {
        var child = children[0];
        var Type = child.type,
            props = child.props;
        output = _react2.default.createElement(Type, _extends({}, props, {
          items: items,
          ObjectContext: ObjectContext
        }));
      } else {
        if (items.length) {
          children = children.filter(function (n) {
            return n && n.type !== _DefaultValue2.default;
          });
          output = items.map(function (n, index) {
            var id = n.id;
            return _react2.default.createElement(ObjectContext.Provider, {
              key: id || index,
              value: _extends({
                object: n
              }, otherData)
            }, children);
          });
        } else {
          output = children.filter(function (n) {
            return n && n.type === _DefaultValue2.default;
          });
        }

        {
          /* output = <Grid
            container
            {...other}
           >
             {}
           </Grid>; */
        }
      }

      return output;
    });
  }; // renderChildren() {
  //   const {
  //     style,
  //     ...other
  //     // } = this.getRenderProps();
  //   } = this.getComponentProps(this);
  //   const {
  //     Grid,
  //   } = this.context;
  //   let children = super.renderChildren();
  //   return <ConnectorContext.Consumer>
  //     {context => {
  //       const {
  //         data,
  //       } = context;
  //       if (!data) {
  //         return null;
  //       }
  //       const {
  //         objects,
  //         objectsConnection,
  //       } = data;
  //       let items = objects ? objects : objectsConnection ? objectsConnection.edges.map(n => n.node) : null;
  //       if (!items) {
  //         return null;
  //       }
  //       return <Grid
  //         container
  //         {...other}
  //       >
  //         {items.length ?
  //           items.map((n, index) => {
  //             const {
  //               id,
  //             } = n;
  //             return <ObjectContext.Provider
  //               key={id || index}
  //               value={{
  //                 object: n,
  //               }}
  //             >
  //               {children}
  //             </ObjectContext.Provider>
  //           })
  //           :
  //           children
  //         }
  //       </Grid>;
  //     }}
  //   </ConnectorContext.Consumer>
  //     ;
  // }


  return ListView;
}(_4.default), _class.defaultProps = _extends({}, _4.default.defaultProps, {
  spacing: 8
}), _class.Name = "ListView", _class.help_url = "https://front-editor.prisma-cms.com/topics/list-view.html", _temp);
exports.default = ListView;